import { Dispatch } from "react";
import { PiPersonArmsSpreadFill } from "react-icons/pi";
import { BiSolidUser } from "react-icons/bi";
import { FaPerson } from "react-icons/fa6";
import { AiOutlineMinusCircle, AiOutlinePlusCircle } from "react-icons/ai";
import { AiOutlineCaretDown, AiOutlineCaretUp } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import * as Actions from "../../store/actions";
import { Popover } from "@headlessui/react";

const PassengerList = ({ dark = false }: { dark?: boolean } = {}) => {
  const dispatch: Dispatch<any> = useDispatch();
  const passenger = useSelector((state: any) => state.form.passenger);

  return (
    <div className="relative inline-block text-left">
      <Popover>
        {({ open, close }) => (
          <>
            <Popover.Button>
              {" "}
              <div>
                <button
                  type="button"
                  className={
                    dark
                      ? "inline-flex gap-1 w-auto text-white font-medium items-center text-sm px-4 py-2  hover:bg-white/10 border-none  hover:rounded-md h-auto rounded-[4px]"
                      : "inline-flex gap-1 w-auto text-[#171717] font-medium items-center text-sm px-4 py-2  hover:bg-[#00000020] border-none  hover:rounded-md h-auto rounded-[4px]"
                  }
                  id="options-menu"
                  aria-haspopup="listbox"
                  aria-expanded="true"
                >
                  <BiSolidUser className={dark ? "text-white" : "text-black"} />
                  {`${
                    passenger.adult > 0
                      ? `${passenger.adult} ${
                          passenger.adult > 1 ? "adults" : "adult"
                        }`
                      : ""
                  } ${
                    passenger.child > 0
                      ? `${passenger.child} ${
                          passenger.child > 1 ? "children" : "child"
                        }`
                      : ""
                  } ${
                    passenger.infant > 0
                      ? `${passenger.infant} ${
                          passenger.infant > 1 ? "infants" : "infant"
                        }`
                      : ""
                  } `}
                  {open ? <AiOutlineCaretUp /> : <AiOutlineCaretDown />}
                </button>
              </div>
            </Popover.Button>
            <Popover.Panel>
              <div className="origin-top-right w-72 z-[2] absolute left-0  p-4 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5">
                <p className="text-black text-sm font-normal  mb-4 font-Poppins">
                  Please select the exact number of passengers to view the best
                  prices
                </p>
                <div className="py-[18px]">
                  {" "}
                  <div className="flex justify-between text-black">
                    <div className="flex gap-1 items-center text-sm">
                      <FaPerson />
                      <span>Adults</span>
                    </div>
                    <div className="flex w-1/4 items-center justify-between text-lg text-orange-500">
                      <AiOutlineMinusCircle
                        className={`cursor-pointer ${
                          passenger.adult > 1
                            ? "hover:text-orange-500"
                            : "text-slate-400"
                        } `}
                        onClick={() => {
                          if (passenger.adult > 1) {
                            dispatch(
                              Actions.setPasseger("adult", passenger.adult - 1)
                            );
                          }
                        }}
                      />
                      <div>{passenger.adult}</div>
                      <AiOutlinePlusCircle
                        className="cursor-pointer hover:text-orange-500"
                        onClick={() => {
                          dispatch(
                            Actions.setPasseger("adult", passenger.adult + 1)
                          );
                        }}
                      />
                    </div>
                  </div>
                  <div className="flex justify-between text-black mt-[22px]">
                    <div>
                      <div className="flex gap-1 text-sm items-center">
                        <PiPersonArmsSpreadFill />
                        <span>Children</span>
                      </div>
                      <p className="font-Poppins text-xs text-slate-500">
                        2–11 years at time of travel
                      </p>
                    </div>
                    <div className="flex w-1/4 items-center justify-between text-lg text-orange-500">
                      <AiOutlineMinusCircle
                        className={`cursor-pointer ${
                          passenger.child === 0
                            ? "text-slate-400"
                            : "hover:text-orange-500"
                        } `}
                        onClick={() => {
                          if (passenger.child > 0) {
                            dispatch(
                              Actions.setPasseger("child", passenger.child - 1)
                            );
                          }
                        }}
                      />
                      <div>{passenger.child}</div>
                      <AiOutlinePlusCircle
                        className="cursor-pointer hover:text-orange-500"
                        onClick={() => {
                          dispatch(
                            Actions.setPasseger("child", passenger.child + 1)
                          );
                        }}
                      />
                    </div>
                  </div>
                  <div className="flex justify-between text-black mt-[22px]">
                    <div>
                      <div className="flex gap-1 text-sm items-center">
                        <PiPersonArmsSpreadFill />
                        <span>Infants (Lap)</span>
                      </div>
                      <p className="font-Poppins text-xs text-slate-500">
                        Under 2 years at time of travel
                      </p>
                    </div>
                    <div className="flex w-1/4 items-center justify-between text-lg text-orange-500">
                      <AiOutlineMinusCircle
                        className={`cursor-pointer ${
                          passenger.infant === 0
                            ? "text-slate-400"
                            : "hover:text-orange-500"
                        } `}
                        onClick={() => {
                          if (passenger.infant > 0) {
                            dispatch(
                              Actions.setPasseger(
                                "infant",
                                passenger.infant - 1
                              )
                            );
                          }
                        }}
                      />
                      <div>{passenger.infant}</div>
                      <AiOutlinePlusCircle
                        className="cursor-pointer hover:text-orange-500"
                        onClick={() => {
                          dispatch(
                            Actions.setPasseger("infant", passenger.infant + 1)
                          );
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div
                  className="w-full flex justify-end cursor-pointer"
                  onClick={() => {
                    close();
                  }}
                >
                  <span>Done</span>
                </div>
              </div>
            </Popover.Panel>
          </>
        )}
      </Popover>
    </div>
  );
};

export default PassengerList;
